// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".a5wEFsUQ07debbrFkY-d2g\\=\\= h3{font-family:BodyFont,sans-serif;font-size:2rem;font-weight:500;line-height:2.9rem}.a5wEFsUQ07debbrFkY-d2g\\=\\= h3,.a5wEFsUQ07debbrFkY-d2g\\=\\= p{margin-bottom:1.2rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textBody": "a5wEFsUQ07debbrFkY-d2g=="
};
module.exports = ___CSS_LOADER_EXPORT___;
